/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Button as AntdButton } from 'antd';
import clsx from 'clsx';

import s from './styles.module.less';

const Button = ({ className, ...props }) => <AntdButton className={clsx(className, s.custom)} {...props} />;

export default Button;
